// frontend/modules/account-settings/components/TransaccList.tsx
import React from 'react';
import {Table, Button, Space, Spin} from 'antd';
import { TransaccDTO } from '@/shared/api/model';

interface TransaccListProps {
    data: TransaccDTO[];
    onEdit: (record: TransaccDTO) => void;
    onDelete: (record: TransaccDTO) => void;
    loading: boolean;
}

export const TransaccList: React.FC<TransaccListProps> = ({
                                                              data,
                                                              onEdit,
                                                              onDelete,
    loading
                                                          }) => {
    const columns = [
        {
            title: '#',
            key: 'index',
            render: (_: any, __: any, index: number) => index + 1
        },
        {
            title: 'GL No',
            dataIndex: 'glNo',
            key: 'glNo'
        },
        {
            title: 'A/c No',
            dataIndex: 'acNo',
            key: 'acNo'
        },
        {
            title: 'Description',
            dataIndex: 'acTitle',
            key: 'acTitle'
        },
        {
            title: 'Account Type',
            dataIndex: 'acctype',
            key: 'acctype',
            render: (type: number) => {
                const types = {
                    0: 'Cash',
                    1: 'Bank',
                    2: 'Transfer'
                };
                return types[type as keyof typeof types] || 'Unknown';
            }
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (record: TransaccDTO) => (
                <Space>
                    <Button type="link" onClick={() => onEdit(record)}>
                        Update
                    </Button>
                    <Button
                        type="link"
                        danger
                        onClick={() => onDelete(record)}
                    >
                        Delete
                    </Button>
                </Space>
            )
        }
    ];

    if(loading) return <Spin size={'large'} />;

    return (
        <Table
            columns={columns}
            dataSource={data}
            rowKey={(record) => `${record.glNo}-${record.acNo}`}
        />
    );
};